"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.carlineEnvkvStrategy = void 0;
const misc_1 = require("../../../utils/misc");
const range_1 = require("../../../utils/range");
const vehicleKey_1 = require("../../../utils/vehicleKey");
const vehicleType_1 = require("../../../utils/vehicleType");
const constants_1 = require("../../constants");
const mustacheRenderer_1 = require("../../renderer/mustacheRenderer");
const textResources_1 = require("../../textResources");
const carlineEnvkvStrategy = ({ carline, locale, i18nlanguage }, ret) => {
    const resources = new textResources_1.I18nText(locale, i18nlanguage);
    const { eecModel } = carline;
    const vehicleType = (0, vehicleType_1.getVehicleTypeForCarline)(carline);
    if ((0, misc_1.isDefined)(eecModel.eecClassCombinedMax) && (0, misc_1.isDefined)(eecModel.eecClassCombinedMin)) {
        const emissionTemplateKey = eecModel.eecClassCombinedMax === eecModel.eecClassCombinedMin ? "vue.eec" : "vue.range.eec";
        ret.formattedCo2Class = (0, mustacheRenderer_1.substituteTemplate)(resources.get((0, vehicleKey_1.getTranslationKeyForVehicleType)(emissionTemplateKey, vehicleType)), {
            eecRange: (0, range_1.formatRangeText)({ min: eecModel.eecClassCombinedMin, max: eecModel.eecClassCombinedMax }),
            eec: eecModel.eecClassCombinedMin,
            footnote: {
                reference: `{${constants_1.FOOTNOTE_REFERENCE}}`,
            },
        });
    }
    if (!eecModel.isHybrid) {
        return ret;
    }
    if ((0, misc_1.isDefined)(eecModel.wltpSustainingCombinedMin) &&
        (0, misc_1.isDefined)(eecModel.wltpSustainingCombinedMax) &&
        (0, misc_1.isDefined)(eecModel.fuelConsumptionWltpUnit)) {
        ret.formattedDischargedConsumption = (0, mustacheRenderer_1.substituteTemplate)(resources.get(`vue.range.consumption.combined.hybrid.discharged`), {
            consumptionRange: (0, range_1.formatRangeValue)(locale, {
                min: eecModel.wltpSustainingCombinedMin,
                max: eecModel.wltpSustainingCombinedMax,
                unit: eecModel.fuelConsumptionWltpUnit,
            }, range_1.CONSUMPTION_FRACTION_DIGITS),
            footnote: {
                reference: `{${constants_1.FOOTNOTE_REFERENCE}}`,
            },
        });
    }
    if ((0, misc_1.isDefined)(eecModel.eecClassSustainingMax) && (0, misc_1.isDefined)(eecModel.eecClassSustainingMin)) {
        const vehicleKey = (0, vehicleKey_1.getVehicleKeyForVehicleType)(vehicleType);
        const emissionTemplateKey = eecModel.eecClassSustainingMin === eecModel.eecClassSustainingMax
            ? `vue.eec.${vehicleKey}.discharged`
            : `vue.range.eec.${vehicleKey}.discharged`;
        ret.formattedDischargedCo2Class = (0, mustacheRenderer_1.substituteTemplate)(resources.get(emissionTemplateKey), {
            eecRange: (0, range_1.formatRangeText)({ min: eecModel.eecClassSustainingMin, max: eecModel.eecClassSustainingMax }),
            eec: eecModel.eecClassSustainingMin,
            footnote: {
                reference: `{${constants_1.FOOTNOTE_REFERENCE}}`,
            },
        });
    }
    return ret;
};
exports.carlineEnvkvStrategy = carlineEnvkvStrategy;
